import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

/**
 * A hover / focus hint on ONE element — the console's tooltip, never the browser's `title`
 * (slow, unstyled, off-brand). `title` is the bold first line (who / which service),
 * `body` what is going on. The child must be a DOM element (it receives the trigger's
 * ref and handlers). Self-contained: it carries its own provider, so it works anywhere.
 * `side` picks where it opens (above by default; the icon rail opens it to the right).
 */
export function Hint({
  title,
  body,
  side,
  children,
}: {
  title?: string | undefined;
  body: string;
  side?: 'top' | 'right' | 'bottom' | 'left' | undefined;
  children: ReactElement;
}) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          {...(side ? { side } : {})}
          className="max-w-xs leading-snug"
          data-testid="hint"
        >
          {title ? <p className="font-semibold">{title}</p> : null}
          <p className="whitespace-pre-line">{body}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
